export default __webpack_public_path__ + "static/media/sconeClassIcon.b898fff6.jpg";